import Loading from '../base/Loading';

interface Props {
  children: any;
  prefix?: any;
  loading?: boolean;
}

const TilesGrid = ({ children, loading, prefix }: Props) => {
  if (loading) return <Loading />;

  return (
    <div>
      {prefix}
      <div className="grid gap-4 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 min-[1510px]:grid-cols-3 min-[2100px]:grid-cols-4 min-[2500px]:grid-cols-5 min-[3000px]:grid-cols-7 p-5">
        {children}
      </div>
    </div>
  );
};

export default TilesGrid;
